import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'; // Importe useNavigate
import { scroller } from 'react-scroll';
import Initial from "../Home/Initial";
import QuoteSection from '../About/QuoteSection';
import About from "../About/About";
import ProfessionalSection from "../About/ProfessionalSection";
import AcademicSection from "../About/AcademicSection";
import Contact from "../Contact/Contact";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const scrollOffset = -90;

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      window.scrollTo(0, 0);
      const targetId = location.state.scrollTo;

      setTimeout(() => {
        if (targetId === 'about') {
          const targetElement = document.getElementById(targetId);
          
          if (targetElement) {
            // Lógica de cálculo idêntica à do Menu.js para consistência
            const elementTop = targetElement.offsetTop;
            const elementHeight = targetElement.offsetHeight;
            const windowHeight = window.innerHeight;

            // Fórmula Geométrica de Centralização
            let scrollTop = elementTop - (windowHeight / 2) + (elementHeight / 2);

            // Ajuste fino opcional: Se achar que a Navbar (90px) está atrapalhando a visão,
            // você pode subtrair um pouco (ex: -45) para subir o elemento um pouco mais.
            // scrollTop = scrollTop - 45; 

            window.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
            });
          }
        } else {
          // Para outros itens (como initial), usa o scroller padrão
          scroller.scrollTo(targetId, {
            smooth: true,
            duration: 500,
            offset: scrollOffset
          });
        }
        
        // 2. LIMPEZA: Limpa o state para evitar que o scroll execute novamente
        // se o usuário navegar "Voltar" ou interagir com a página.
        navigate(location.pathname, { replace: true, state: {} });

      }, 150); // Delay para garantir que a página renderizou
    }
  }, [location, navigate]); // Adicione as dependências corretas

  return (
    <div id="pages" className="container-fluid p-0">
      <Initial id="initial" className="section"/>
      <QuoteSection id="quote-section" className="section"/>
      <About id="about" className="section"/>
      <ProfessionalSection id="professional-section" className="section"/>
      <AcademicSection id="academic-tesection" className="section"/>
      <Contact id="contact" className="section"/>
    </div>
  );
}

export default Home;